/**
 * Decide whether payment methods belong in the top-wrapper.
 *
 * Invariant: top-wrapper hosts payment methods iff a trip section
 * (open-ticket selector or return-date input) is rendered there.
 * Intentionally NOT gated by hasTripSwitch — when no switch is shown
 * (e.g. optInReturn=false, showOpenTicket=false), payment methods still
 * belong in the top-wrapper alongside the single trip section.
 *
 * @param {object} params
 * @param {boolean} params.showOpenTicket
 * @param {boolean} params.calendarOpen
 * @param {boolean} params.hideReturn
 * @returns {boolean}
 */
export const computeHasPaymentMethodsInTop = ({
  showOpenTicket,
  calendarOpen,
  hideReturn,
}) => (showOpenTicket && !calendarOpen) || !hideReturn;
